export default {"src":"/_next/static/media/minus.7bd8a98f.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};